import React, { Component } from 'react'

export default class PageNotFound extends Component {
        render() {
                return (
                        <div>
                                PAGE NOT FOUND
                        </div>
                )
        }
}
